(() => {
  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent('ttt:analytics', { detail: { name, ...detail } }));
    window.dataLayer?.push({ event: name, ...detail });
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-ttt-event]');
    if (!target) return;
    const link = event.target.closest('a');
    if (target.dataset.tttEvent.endsWith('_product_click') && !link) return;
    emit(target.dataset.tttEvent, {
      item_name: target.dataset.tttName || target.textContent.trim(),
      link_url: link?.href || target.href || null,
      placement: target.dataset.tttPlacement || null,
    });
  });

  document.querySelectorAll('predictive-search [data-predictive-search]').forEach((results) => {
    new MutationObserver(() => {
      const total = Number(results.querySelector('[data-total-results]')?.dataset.totalResults);
      if (Number.isFinite(total) && total === 0) {
        const query = results.closest('predictive-search')?.querySelector('input[type="search"]')?.value.trim();
        if (query && results.dataset.lastZeroQuery !== query) {
          results.dataset.lastZeroQuery = query;
          emit('predictive_search_zero_results', { search_term: query });
        }
      }
    }).observe(results, { childList: true });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('select[name="sort_by"], input[name="sort_by"]')) {
      emit('collection_sort_use', { value: event.target.value });
      return;
    }
    if (event.target.closest('facet-filters-form')) emit('collection_filter_use', { value: event.target.value || null });
  });

  const rewards = document.querySelector('[data-ttt-rewards-program]');
  if (rewards) {
    fetch(rewards.dataset.endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Rewards program returned ${response.status}`);
        return response.json();
      })
      .then((program) => {
        if (!program.enabled) {
          rewards.hidden = true;
          return;
        }
        const earn = rewards.querySelector('[data-rewards-earn]');
        const bonus = rewards.querySelector('[data-rewards-bonus]');
        const redeem = rewards.querySelector('[data-rewards-redeem]');
        if (earn) earn.textContent = `${program.website_earn_rate_bp / 100}% back`;
        if (bonus) bonus.textContent = program.signup_bonus_active ? `${program.signup_bonus_points} points` : 'Member offers';
        if (redeem) redeem.textContent = program.redemption_enabled ? `From ${program.minimum_redemption} points` : 'Member perks';
        rewards.removeAttribute('aria-busy');
      })
      .catch(() => {
        rewards.querySelectorAll('[data-rewards-dynamic]').forEach((node) => node.closest('.ttt-home-rewards__fact')?.remove());
        rewards.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-youtube-id]');
    if (!trigger) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(trigger.dataset.youtubeId)}?autoplay=1`;
    frame.title = trigger.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    trigger.replaceWith(frame);
  });
})();
